import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {App} from "./App";
import "@twoshot/ui-kit/tokens.css";
import "@twoshot/ui-kit/page.css";
import "@twoshot/ui-kit/phone.css";
import "./styles.css";
import {colors} from "../../shared/branding.ts";
import {adoptInjectedDeployment} from "./deployment.ts";
import {signInTitle} from "../../shared/deployment-config.ts";
import {OrbBackdrop} from "./OrbBackdrop";

// Adopt the server-injected deployment config (window.__AUTH_CONFIG__) before
// anything renders. With nothing injected this returns the compiled-in TwoShot
// defaults, so TwoShot's own page is unchanged.
const deployment = adoptInjectedDeployment();
const brand = {...colors, ...(deployment.colors ?? {})};
const root = document.documentElement;
const darkOnly = deployment.appearance.theme === "dark";

// The deployment's accent is the page's one primary; its background is the dark page colour.
root.style.setProperty("--page-bg", brand.bg);
root.style.setProperty("--primary-solid", brand.accent);
root.style.setProperty("--primary-solid-hover", `color-mix(in srgb, ${brand.accent} 88%, white)`);
root.style.setProperty("--primary-solid-active", brand.accentActive);
// A dark-only product pins the kit tokens dark; the others follow the system setting.
if (darkOnly) root.classList.add("dark");
else root.style.removeProperty("--page-bg");
document.querySelector('meta[name="color-scheme"]')?.setAttribute("content", darkOnly ? "dark" : "light dark");
const themeColor = document.querySelector('meta[name="theme-color"]');
if (darkOnly) themeColor?.setAttribute("content", brand.bg);
else {
    themeColor?.setAttribute("media", "(prefers-color-scheme: dark)");
    themeColor?.setAttribute("content", brand.bg);
    const light = document.createElement("meta");
    light.name = "theme-color";
    light.media = "(prefers-color-scheme: light)";
    light.content = "#f7f7f7";
    themeColor?.after(light);
}
document.title = signInTitle(deployment);

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <OrbBackdrop/>
        <App/>
    </StrictMode>
);
